import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * Request builders for the general `EmployeePlanAccount` resource (not
 * SLR-specific — see `slr-loan-standing-verification.ts` for that surface).
 */

const employeePlanAccountUrl = (path: string) => {
  const opts: QueryUrlOptions = {
    identifier: { type: 'employee-plan-accounts' },
    op: 'query',
    resourcePath: 'employee-plan-accounts',
  };
  return `${buildBaseURL(opts)}/${path.replace(/^\/+/, '')}`;
};

/**
 * PATCH /employee-plan-accounts/:id — move this record to `position` (1-indexed)
 * among its siblings for the same employee_plan. This is a list-reorder: the
 * server pulls the record from its old slot, inserts it at the new one, and
 * shifts everyone else — callers do not need to compute the full ordering.
 */
export function updateContributionOrderRequest(
  employeePlanAccountId: string,
  position: number
): RequestInfo {
  return {
    url: employeePlanAccountUrl(employeePlanAccountId),
    method: 'PATCH',
    body: JSON.stringify({
      data: {
        type: 'employeePlanAccounts',
        id: employeePlanAccountId,
        attributes: { contributionOrder: position },
      },
    }),
    cacheOptions: { [SkipCache]: true },
  };
}
